import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar, getDatasetAtEvent, getElementAtEvent } from "react-chartjs-2";
import ChartDataLabels from "chartjs-plugin-datalabels";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ChartDataLabels
);

const VerticalBarChart = ({ options, data, handleClick }) => {
  const barOptions = {
    responsive: true,
    interaction: {
      mode: "nearest",
      intersect: true, // asegúrate de que intersect sea true
    },
    plugins: {
      legend: {
        position: "top",
        display: false,
      },
      title: {
        display: false,
      },
      datalabels: {
        color: "#0E488E",
        anchor: "end",
        align: "start",
        font() {
          return {
            size: 16,
            weight: "bolder",
          };
        },
        offset: -30,
        formatter: (value, context) => {
          const percent = value + "%";
          const dataset = context.chart.data.datasets[0];
          const count = dataset.metaData?.[context.dataIndex]?.countData ?? "";
          return `${percent} (${count})`;
        },
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        max: 120,
        ticks: {
          stepSize: 10,
          callback: function (tickValue) {
            const numericValue =
              typeof tickValue === "number" ? tickValue : parseFloat(tickValue);
            return numericValue <= 100 ? `${numericValue}%` : null;
          },
        },
      },
    },
    ...options,
    onClick: (event, elements) => {
      if (elements.length > 0) {
        const [element] = elements;
        handleClick(element.index);
      }
    },
  };

  return <Bar options={barOptions} data={data} />;
};

export default VerticalBarChart;
